import mapFunction from './mapResource';

export default mapFunction('tablet', {
    isFetching: false,
    data: {
        id: 0,
        name: ''
    } 
});